import template from './proxyingCustomerInfoPanel.html';
import controller from './proxyingCustomerInfoPanel.controller';

let proxyingCustomerInfoPanelComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default proxyingCustomerInfoPanelComponent;



// WEBPACK FOOTER //
// ./app/components/proxyingCustomerInfoPanel/proxyingCustomerInfoPanel.component.js